module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "代购单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入客户代购单号",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.purchasingNo),
      callback: function($$v) {
        _vm.$set(_vm.filters, "purchasingNo", $$v)
      },
      expression: "filters.purchasingNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.chengshi),
      callback: function($$v) {
        _vm.$set(_vm.filters, "chengshi", $$v)
      },
      expression: "filters.chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "代购状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.statusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "statusId", $$v)
      },
      expression: "filters.statusId"
    }
  }, _vm._l((_vm.statusoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "客户电话："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入联系电话",
      "maxlength": "11",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\d{0})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.$set(_vm.filters, "phone", $$v)
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    },
    attrs: {
      "label": "代　购　价："
    }
  }, [_c('div', {
    staticStyle: {
      "width": "90%",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入预算范围",
      "maxlength": "9",
      "type": "text",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.filters.minPurchasingPrice),
      callback: function($$v) {
        _vm.$set(_vm.filters, "minPurchasingPrice", $$v)
      },
      expression: "filters.minPurchasingPrice"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "margin": "0 5px"
    }
  }, [_vm._v("　至　")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入预算范围",
      "maxlength": "9",
      "type": "text",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.filters.maxPurchasingPrice),
      callback: function($$v) {
        _vm.$set(_vm.filters, "maxPurchasingPrice", $$v)
      },
      expression: "filters.maxPurchasingPrice"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("客户代购单")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代购单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.PurchasingNo,
            "label": scope.row.PurchasingNo
          }
        }, [_vm._v(_vm._s(scope.row.PurchasingNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户姓名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.UserName,
            "label": scope.row.UserName
          }
        }, [_vm._v(_vm._s(scope.row.UserName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Phone,
            "label": scope.row.Phone
          }
        }, [_vm._v(_vm._s(scope.row.Phone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "代购总金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.FinalPrice,
            "label": scope.row.FinalPrice
          }
        }, [_vm._v(_vm._s(scope.row.FinalPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所在城区",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.CityName,
            "label": scope.row.CityName
          }
        }, [_vm._v(_vm._s(scope.row.CityName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.StatusName,
            "label": scope.row.StatusName
          }
        }, [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.Id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看\r\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.PurchasingAgentDialog,
      "show-close": false,
      "size": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.PurchasingAgentDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("代购单号: " + _vm._s(_vm.orderdetailList.PurchasingNo))]), _vm._v(" "), _c('li', [_c('el-button', {
          staticStyle: {
            "margin-top": "-10px"
          },
          attrs: {
            "type": "danger"
          },
          on: {
            "click": _vm.cancelForm
          }
        }, [_vm._v("关 闭")])], 1)])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('div', {
    staticClass: "divHone"
  }, [_c('div', [_vm._v("代购信息")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.orderdetailList.StatusName))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("所在城区：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.orderdetailList.CityName))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("代购总价：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.orderdetailList.FinalPrice))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("代购服务费：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.orderdetailList.ServiceFeeName))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "33%",
      "display": "flex"
    }
  }, [_c('p', {
    staticClass: "watch_first",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("备注：")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "85%",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.orderdetailList.Remark))])])]), _vm._v(" "), _c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("代购协议合同")]), _vm._v(" "), _c('div', {
    staticClass: "upPictures"
  }, [(_vm.flag < 5) ? _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderdetailList.StatusName == '代购中'),
      expression: "orderdetailList.StatusName == '代购中'"
    }],
    staticClass: "daigouUp",
    attrs: {
      "action": "",
      "multiple": "",
      "before-upload": _vm.beforeAvatarUpload,
      "accept": ".png, .jpg,.jpeg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.detailImgUrlarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "daigouUp",
      attrs: {
        "data-img": item
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgUrl,
        "preview-src-list": [item.ImgUrl]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "divP"
  }, [(_vm.orderdetailList.StatusName == '代购中') ? _c('p', [_vm._v("请上传代购协议合同")]) : _c('p', [_vm._v("代购协议合同")])]), _vm._v(" "), _c('div', {
    staticClass: "purchasingGoods"
  }, [_vm._v("代购清单")]), _vm._v(" "), _c('div', {
    staticClass: "detailedListBottom"
  }, _vm._l((_vm.PurchasingGoodsListsImages), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "daigouUp",
      attrs: {
        "data-img": item
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px"
      },
      attrs: {
        "src": item.ImgUrl,
        "preview-src-list": [item.ImgUrl]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.orderdetailList.StatusName == '代购中') ? _c('div', {
    staticClass: "drawer_foot"
  }, [_c('div', {
    staticClass: "labelInput"
  }, [_c('label', [_vm._v("最终代购价:　")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "请输入最终代购价",
      "maxlength": "9",
      "type": "text",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.finalPurchasePrice),
      callback: function($$v) {
        _vm.finalPurchasePrice = $$v
      },
      expression: "finalPurchasePrice"
    }
  }), _vm._v(" "), _c('label', [_vm._v("　最终代购服务费: "), _c('strong', [_vm._v(_vm._s(_vm.monitorServiceCharge.toFixed(2)))])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.endUploadContract
    }
  }, [_vm._v("已找到合适的商品且与客户沟通确认,上传代购协议合同")])], 1) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pub_dialog",
    attrs: {
      "visible": _vm.isShowThumbnailImageDialog,
      "title": "图片查看",
      "width": "96%",
      "top": "50px"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowThumbnailImageDialog = $event
      },
      "closed": _vm.clearThumbnailImg
    }
  }, [_c('div', {
    staticClass: "imgDiv"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgBigUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imgFiveDiv"
  }, _vm._l((_vm.imgList), function(itemImg, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": itemImg
      },
      on: {
        "click": function($event) {
          _vm.imgBigUrl = itemImg
        }
      }
    })
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-487fc12e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/platformManagement/CustomerPurchaseOrder.vue
// module id = 1687
// module chunks = 3